<template>
  <div class="remark-container">
    <div class="remark-content">
      <div class="remark-title">
        添加备注
        <img class="close-icon" src="https://logo.wondercv.com/banners/urFfJwZOzxhKzHQ.png" alt="" @click="close">
      </div>
      <el-input
        v-model="remark"
        type="textarea"
        placeholder="请输入备注"
        :rows="4"
      />
      <div class="remark-btn-content">
        <el-button class="cancel-btn" @click="close">取消</el-button>
        <el-button
          type="primary"
          style="background-color: #ff6644; border-color: #ff6644"
          @click="confirm"
        >
          保存备注
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
export default {
  name: "BlockRemark",
  props: {
    operationTableItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      remark: this.operationTableItem.remark || "",
    };
  },
  methods: {
    close(type) {
      this.$emit("close", type);
    },
    async confirm() {
      try {
        const res = await api.campus.changeRecruiteStep(
          this.operationTableItem.id,
          {
            remark: this.remark,
          }
        );
        if (res.code === 1000) {
          this.remark = "";
          this.$message.success("已添加备注");
          this.close("refresh");
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("保存备注失败");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.remark-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  .remark-content {
    width: 520px;
    height: 252px;
    background: #fff;
    border-radius: 8px;
    padding: 24px 32px;
    box-sizing: border-box;
    .remark-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      color: #1d2129;
      margin-bottom: 24px;
      .close-icon {
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
    }
    .remark-btn-content {
      margin-top: 24px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .cancel-btn {
        border-radius: 4px;
        background: #f2f3f5;
        color: #4e5969;
        border: none;
      }
    }
  }
}
</style>
